import FinancialDocumentsWorkspace from "components/Financial/FinancialDocumentsWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import FarmBaseAcreWorkspace from "components/Vault/Farm/FarmBaseAcreWorkspace";
import FarmDetailWorkspace from "components/Vault/Farm/FarmDetailWorkspace";
import FarmFieldCropWorkspace from "components/Vault/Farm/FarmFieldCropWorkspace";
import FarmListWorkspace from "components/Vault/Farm/FarmListWorkspace";
import FieldWorkspace from "components/Vault/Farm/FieldWorkspace";
import VaultCurrentWorkspace from "components/Vault/Farm/VaultCurrentWorkspace";
import VaultPotentialWorkspace from "components/Vault/Farm/VaultPotentialWorkspace";
import VaultPrintWorkspace from "components/Vault/Farm/VaultPrintWorkspace";

export const vaultRoutes = [
  {
    path: "/vault",
    element: <RouteLayout />,
    children: [{ index: true, element: <VaultCurrentWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/potential",
    element: <RouteLayout />,
    children: [{ index: true, element: <VaultPotentialWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Potential" />,
  },
  {
    path: "/vault/print/:crop_year",
    element: <RouteLayout />,
    children: [{ index: true, element: <VaultPrintWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/:crop_year/:location_state_name/:location_county_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/:crop_year/:location_state_name/:location_county_name/:producer_farm_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmDetailWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/:crop_year/:location_state_name/:location_county_name/:producer_farm_id/:producer_farm_field_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <FieldWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/:crop_year/:location_state_name/:location_county_name/:producer_farm_id/baseAcre/:producer_farm_base_acre_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmBaseAcreWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/:crop_year/:location_state_name/:location_county_name/:producer_farm_id/:producer_farm_field_id/:producer_farm_field_crop_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmFieldCropWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Vault" />,
  },
  {
    path: "/vault/documents",
    element: <RouteLayout />,
    children: [{ index: true, element: <FinancialDocumentsWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Documents" />,
  },
];
